// extracted by mini-css-extract-plugin
export default {"item":"CardItem_item__vrct6"};